import { Fragment } from "react";
import {
  GroupProcess,
  Requirement,
  MaturityLevel,
  MaturityLevelType,
  RequirementColumn,
  Department,
} from '../../types/data';
import { AdditionalInformation, AnswerContext } from '../../types/data';
import Question from '../question/question';
import {
  calculatesAverageValue,
  filteredAnswers,
  calculateIndentColumn,
} from '../../utils/utils';
import { Report } from '../../types/table';
import { circle, link } from "../../ui-icons/icons";
import { TooltipItem } from "src/utils/Tooltip";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { setCondition, setStatusQuestionary } from "src/modules/vpo/actions";
import { selectItems } from "src/modules/vpo/selectors/selectItems";
import { useSelector } from "react-redux";
import { addItem } from "src/modules/spItems/actions";
import { VPOStatusQuestionnaireListName } from "src/api/config";
import { getProductionDepartments } from "../../utils/data-table";
import LazyRender from "../lazy-render/lazy-render";
import { MarkdownHooks } from 'react-markdown';

const order = {
  "Все": 0,
  "I": 1,
  "II": 2,
  "III": 3,
  "IV": 4
};

const COLUMNS = {
  '1': {
    width: '100px',
    indent: '0',
  },
  '2': {
    width: '100px',
    indent: '100px',
  },
  '3': {
    width: '100px',
    indent: '200px',
  },
  '4': {
    width: '100px',
    indent: '0',
    indentFactory: '300px',
    indentRegion: '200px',
  },
  '5': {
    width: '76px',
    indent: '100px',
    indentFactory: '400px',
    indentRegion: '300px',
  },
  '6': {
    width: '350px',
    indent: '176px',
    indentFactory: '476px',
    indentRegion: '376px',
  },
  '7': {
    width: '100px',
    indent: '526px',
    indentRegion: '726px',
  },
};

const groupBy = (arr: Requirement[], prop: keyof Requirement) => {
  return arr.reduce((acc, item: Requirement) => {
    const key = String(item[prop]);

    if (!(key in acc)) {
      acc[key] = [item];
    } else {
      acc[key].push(item);
    }

    return acc;
  }, {} as Record<string, Requirement[]>);
};

type RowProps = GroupProcess &
  Omit<RequirementColumn, 'name' | 'columnRequirements'> & {
    category: Report;
    departments: Department[];
    answerContext: AnswerContext;
    onCreateQuestionnaire: () => void;
    onOpenModal?: (data?: AdditionalInformation) => void;
    context?: any;
    isCompleted?: boolean;
  };

  function Row({
    title,
    requirements,
    information,
    year,
    month,
    departments,
    factory,
    completedAssessment,
    completionDate,
    category,
    answerContext,
    onCreateQuestionnaire,
    onOpenModal,
    context,
    isCompleted
  }: RowProps) {
    const data = Object.entries(groupBy(requirements, 'maturityLevel')).sort((a, b) => {
      return order[a[0]] - order[b[0]];
    });

    console.log('maturityLevel', data)
    console.log('start')

    const getClassName = (value: number | 'N/A') => {
      if (value === 'N/A') return 'bg-gray-200';
      if (value <= 59) return 'bg-pink-300';
      if (value >= 60 && value <= 69) return 'bg-yellow-300';
      if (value >= 70) return 'bg-green-300';
    };

    return (
      <>
        {data.map(([maturityLevel, arrCell], idx) => (
          <Fragment key={idx}>
            {arrCell.map((el, index) => (
              <LazyRender key={index}>

                  {idx === 0 &&
                    index === 0 &&
                    (category === 'factory' || category === 'region') && (
                      <>
                        <td
                          rowSpan={requirements.length}
                          className={`sticky z-10 border border-gray-400 bg-white px-2.5 py-4 text-xs before:absolute before:right-[-1px] before:top-0 before:block before:h-full before:w-[1px] before:bg-gray-400`}
                          style={{
                            left: COLUMNS['1'].indent,
                            width: `${COLUMNS['1'].width}`,
                          }}
                        >
                          {year}
                        </td>

                        <td
                          rowSpan={requirements.length}
                          className={`sticky z-10 border border-gray-400 bg-white px-2.5 py-4 text-xs before:absolute before:right-[-1px] before:top-0 before:block before:h-full before:w-[1px] before:bg-gray-400`}
                          style={{
                            left: COLUMNS['2'].indent,
                            width: `${COLUMNS['2'].width}`,
                          }}
                        >
                          {month}
                        </td>
                        {category === 'factory' && (
                          <td
                            rowSpan={requirements.length}
                            className={`sticky z-10 border border-gray-400 bg-white px-2.5 py-4 text-xs before:absolute before:right-[-1px] before:top-0 before:block before:h-full before:w-[1px] before:bg-gray-400`}
                            style={{
                              left: COLUMNS['3'].indent,
                              width: `${COLUMNS['3'].width}`,
                            }}
                          >
                            {factory}
                          </td>
                        )}
                      </>
                    )}

                  {idx === 0 && index === 0 && (
                    <td
                      rowSpan={requirements.length}
                      className="sticky z-10 border border-gray-400 bg-white px-1 py-2 text-center text-xs before:absolute before:right-[-1px] before:top-0 before:block before:h-full before:w-[1px] before:bg-gray-400 "
                      style={{
                        left: calculateIndentColumn(category, COLUMNS['4']),
                        width: `${COLUMNS['4'].width}`,
                      }}
                      onClick={
                        information ? () => onOpenModal?.(information) : undefined
                      }
                    >
                      <span className={`text-gray-500 ${information && 'cursor-pointer underline decoration-dashed hover:text-[#012169]'}`}>{title}</span>
                    </td>
                  )}

                  {index === 0 && (
                    <td
                      rowSpan={arrCell.length}
                      className={`sticky z-10 border border-gray-400 px-2.5 py-2 text-center text-xs before:absolute before:right-[-1px] before:top-0 before:block before:h-full before:w-[1px] before:bg-gray-400 ${maturityLevel === 'Все' && 'bg-white'} ${maturityLevel === 'I' && 'bg-pink-300'} ${maturityLevel === 'II' && 'bg-yellow-300'} ${maturityLevel === 'III' && 'bg-green-300'} ${maturityLevel === 'IV' && 'bg-blue-300'}`}
                      style={{
                        left: calculateIndentColumn(category, COLUMNS['5']),
                        width: `${COLUMNS['5'].width}`,
                      }}
                    >
                      {maturityLevel}
                    </td>
                  )}

                  <td
                    className={`sticky z-10 border border-gray-400 bg-white px-2.5 py-2 text-xs before:absolute before:right-[-1px] before:top-0 before:block before:h-full before:w-[1px] before:bg-gray-400`}
                    style={{
                      left: calculateIndentColumn(category, COLUMNS['6']),
                      width: `${COLUMNS['6'].width}`,
                    }}
                  >
                    <div className="flex items-center gap-x-2 justify-between">
                      <div className='wysiwyg'>
                        <MarkdownHooks>{el.title}</MarkdownHooks>
                      </div>
                      {(el.information || el.connectionColumns) && (
                        <div className="flex shrink-0 gap-x-1">
                          {el.information && (
                            <div
                              className="flex-shrink-0 cursor-pointer"
                              onClick={
                                el.information
                                  ? () => onOpenModal?.(el.information)
                                  : undefined
                              }
                            >
                              <TooltipItem
                                position="left"
                                tooltipsText={'Дополнительная информация по внедрению требования'}
                              >
                                {circle}
                              </TooltipItem>
                            </div>
                          )}

                          {el.connectionColumns && (
                            <div
                              className="flex-shrink-0 cursor-pointer"
                              onClick={
                                el.connectionColumns
                                  ? () => onOpenModal?.(el.connectionColumns)
                                  : undefined
                              }
                            >
                              <TooltipItem
                                position="left"
                                tooltipsText={'Связь с другими колоннами'}
                              >
                                {link}
                              </TooltipItem>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </td>

                  {(category === 'region' || category === 'default') && (
                    <td
                      className={`sticky z-10 border border-gray-400 bg-white px-2.5 py-2 text-xs break-words before:absolute before:right-[-1px] before:top-0 before:block before:h-full before:w-[1px] before:bg-gray-400`}
                      style={{
                        left: calculateIndentColumn(category, COLUMNS['7']),
                        width: `${COLUMNS['7'].width}`,
                      }}
                    >
                      {el.indicator}
                    </td>
                  )}

                  {category !== 'region' &&

                  el.answers.map((item, index) => (
                        <td
                          key={index}
                          className={`border border-gray-400 px-2.5 py-2 text-xs ${item.isAudit ? 'bg-[#FEF3C7]' : ''}`}
                        >
                          <Question
                            data={item}
                            requirementId={el.requirementId}
                            requirementTitle={el.title}
                            blockId={el.blockId}
                            blockTitle={el.blockTitle}
                            processId={el.processId}
                            processTitle={el.processTitle}
                            answerContext={{...answerContext, requirementId: el.requirementId}}
                            onCreateQuestionnaire={onCreateQuestionnaire}
                            context={context}
                            isCompleted={isCompleted as boolean}
                          />
                        </td>
                    ))}

                  {category !== 'region' && (
                    <>
                      <td
                        className={`border border-gray-400 px-2.5 py-2 text-center text-xs ${getClassName(calculatesAverageValue(filteredAnswers(el.answers, departments)))}`}
                      >
                        {calculatesAverageValue(filteredAnswers(el.answers, getProductionDepartments(departments)))}
                        {calculatesAverageValue(filteredAnswers(el.answers, getProductionDepartments(departments))) !==
                          'N/A' && '%'}
                      </td>

                      <td
                        className={`border border-gray-400 px-2.5 py-2 text-center text-xs ${getClassName(calculatesAverageValue(el.answers))}`}
                      >
                        {calculatesAverageValue(el.answers)}
                        {calculatesAverageValue(el.answers) !== 'N/A' && '%'}
                      </td>
                    </>
                  )}

                  {category === 'region' &&
                    el.answersFactory &&
                    el.answersFactory.map((factory, index) => (
                      <td
                        key={index}
                        className={`border border-gray-400 px-2.5 py-2 text-center text-xs ${getClassName(calculatesAverageValue(factory.answersFactory))}`}
                      >
                        {calculatesAverageValue(factory.answersFactory)}
                        {calculatesAverageValue(factory.answersFactory) !== 'N/A' &&
                          '%'}
                      </td>
                    ))}

                  {category === 'region' &&
                    el.answersFactory &&
                    el.answersFactory.length > 1 && (
                      <th
                        className={`w-[116px] border border-gray-400 px-2.5 py-4 text-center text-xs font-medium ${getClassName(calculatesAverageValue(requirements, undefined, undefined, undefined, el.name))}`}
                      >
                        {calculatesAverageValue(
                          requirements,
                          undefined,
                          undefined,
                          undefined,
                          el.name,
                        )}
                        {calculatesAverageValue(
                          requirements,
                          undefined,
                          undefined,
                          undefined,
                          el.name,
                        ) !== 'N/A' && '%'}
                      </th>
                    )}

                  {category === 'factory' && (
                    <>
                      <th className="w-[148px] border border-gray-400 border-b-black px-2.5 py-4 text-center text-xs font-medium">
                        {completedAssessment}
                      </th>
                      <th className="w-[148px] border border-gray-400 border-b-black px-2.5 py-4 text-center text-xs font-medium">
                        {completionDate}
                      </th>
                    </>
                  )}
              </LazyRender>
            ))}
          </Fragment>
        ))}
      </>
    );
  }

export default Row;
